import { render, staticRenderFns } from "./32.vue?vue&type=template&id=106b3601&"
import script from "./32.vue?vue&type=script&lang=js&"
export * from "./32.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports